// Both revenue surfaces explain the same server calculation through one copy.
export default function RevenueCalculationExplanation() {
  return (
    <div className="revenue-calculation-explanation">
      <p><b>הוצאות:</b> רכש ששויך לקטגוריות העסק. רכש ללא שיוך מוצג בנפרד ולא נכלל בהוצאות או ב-Food Cost.</p>
      <p>ההוצאות נספרות רק בימים בתקופה שהוזנה להם הכנסה או שסומנו כ<b>יום סגירה</b>.
        רכש מימים ללא דיווח, כולל ימים עתידיים, לא נכלל בהוצאות או ב-Food Cost.</p>
      <p><b>% מההכנסות בכל קטגוריה:</b> הרכש בקטגוריה חלקי סך ההכנסות של המסעדה, כפול 100.
        כל קטגוריה מחושבת מול אותן הכנסות.</p>
      <p><b>Food Cost:</b> סך הרכש בקטגוריות שסומנו ב-Food Cost, באותם ימים שנספרו,
        חלקי סך ההכנסות של המסעדה, כפול 100. החישוב מבוסס על רכש, ולא על ספירות מלאי.
        שינוי הסימון מחשב מחדש גם תקופות עבר.</p>
      <p>כל הסכומים <b>ללא מע״מ</b>. ההכנסות נרשמות כולל מע״מ מדוח Z,
        והנטו מחושב לפי שיעור המע״מ של המסעדה.
        נספרים רק <b>מסמכים מאושרים</b>; טיוטות לא נכללות.
        כשאין הכנסות חיוביות בתקופה, האחוזים מוצגים כמקף.</p>
    </div>
  );
}
